import { SegmentedControl } from "@/shared/rd";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { dateDefaults } from "../services/search-params";
const copy = keys.whatsapp;

const PRESETS = [
  [1, copy.today],
  [7, copy.last7Days],
  [30, copy.last30Days],
  [60, copy.last60Days],
  [90, copy.last90Days],
] as const;

/**
 * The UTC date shortcuts as one segmented control. "Choose dates" is the
 * pressed segment whenever the range is not a shortcut, and opens the custom
 * dates. The range itself is written next to it.
 */
export function DatePresets({
  dateFrom,
  dateTo,
  onRange,
  onCustom,
}: {
  dateFrom: string;
  dateTo: string;
  onRange: (range: { dateFrom: string; dateTo: string }) => void;
  onCustom: () => void;
}) {
  const t = useTranslations();
  const now = new Date();
  const ranges = PRESETS.map(([days, label]) => ({
    value: String(days),
    label: t(label),
    range: dateDefaults(now, days),
  }));
  const current =
    ranges.find((item) => item.range.dateFrom === dateFrom && item.range.dateTo === dateTo)?.value ??
    "custom";
  return (
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12 }}>
      <SegmentedControl
        label={t(copy.filters)}
        value={current}
        options={[
          ...ranges.map(({ value, label }) => ({ value, label })),
          { value: "custom", label: t(copy.customDates) },
        ]}
        onChange={(value) => {
          const chosen = ranges.find((item) => item.value === value);
          if (chosen) onRange(chosen.range);
          else onCustom();
        }}
      />
      <span style={{ fontSize: 13, color: "var(--rd-text-tertiary)" }}>
        <bdi>
          <time dateTime={dateFrom}>{dateFrom}</time> — <time dateTime={dateTo}>{dateTo}</time> (UTC)
        </bdi>
      </span>
    </div>
  );
}
